import Vue from 'vue';
import md5 from 'crypto-js/md5';


import { common } from '@tencent/ceiba-base-components';
const queryGameInfo = async (gid) => {
  if (!gid) {
    return {};
  }
  return   await Vue.prototype.$axiosInstance.get(`https://wang.xinyue.qq.com/api/fly/getPkgByGid?gid=${gid}`);
};
//
const queryGamePackageName = (() => {
  let  packageName = '';
  return async (gid) => {
    if (!packageName) {
      const gameInfo = await  queryGameInfo(gid);
      const { ret, info = {} } = gameInfo || {};
      if (ret !== 0) {
        Vue.prototype.alert('系统繁忙，请刷新页面重试');
        console.error('query gameInfo in queryGamePackageName function  return = ', gameInfo);
        packageName = '';
      }
      const { androidPkgName = '' } = info;
      if (!androidPkgName) {
        console.error('query gameInfo in queryGamePackageName androidPkgName  is empty = ', gameInfo);
      }
      packageName  = androidPkgName;
    }
    return packageName;
  };
})();

// 查询用户预约功能
const queryUserSubscription  = async  (gid) => {
  // eslint-disable-next-line no-param-reassign
  gid  = parseInt(gid, 10) || 0;
  if (gid <= 0) return false;
  const response = await Vue.prototype.$requestInstance.post('https://agw.xinyue.qq.com/XySrv.SubscriptionSrv/GetUserSubscription', {});
  console.log('queryUserSubscription response =', response);
  const { ret, gids  = [] } = response || {};
  if (ret !== 0) {
    console.error('queryUserSubscription error response =', response);
    return  false;
  }
  const checkRes = gids.indexOf(gid) > -1;
  console.log('queryUserSubscription checkRes = ', checkRes);
  return checkRes;
};
// 保存预约功能
const saveMobSubscription  = async  ({ gid, mobile, countrycode, switch_status }) => {
  const data = { gid, mobile, countrycode, switch_status };
  const url = 'https://agw.xinyue.qq.com/XySrv.SubscriptionSrv/ModSubscription';
  return   await Vue.prototype.$requestInstance.post(url, data);
};
// 获取俱乐部推荐
const getCommonRecommendEncodeCardByScene = async  ({ scene, gid }) => {
  const data = { scene, gid };
  const url = 'https://bgw.xinyue.qq.com/doraemon.FeedsShowPbSrv/PbGetCommonRecommendEncodeCardByScene';
  return await Vue.prototype.$requestInstance.post(url, data);
};

// 获取俱乐部推荐
const getTgclubPhoneBind = async  () => {
  const url = 'https://bgw.xinyue.qq.com/XySrv.UserSrv/GetUserMobileApp';
  return await Vue.prototype.$requestInstance.post(url);
};
// 安卓上报静默下载
const reportSilentDownload =  async  ({ gid, packageName, operType }) => {
  const params = JSON.stringify({ gid: gid.toString(), packageName, operType: parseInt(operType, 10) });
  const timeStamp = Math.floor(new Date().getTime() / 1000);
  const url = 'saveAutoDownloadGames';
  const acctType = common.tool.getCookie('acctype') || 'qq';
  let appid = common.tool.getCookie('appid');
  let openid = common.tool.getCookie('openid');
  let accessToken =  common.tool.getCookie('access_token');
  if (acctType === 'qq') {
    appid = '1104370886';
    let  cookieContent =  common.tool.getCookie('IED_LOG_INFO2') || '';
    console.log('cookieContent =', cookieContent);
    if (cookieContent) {
      cookieContent = decodeURIComponent(cookieContent);
    }
    openid =  common.tool.getQueryparams('uin', cookieContent);
    accessToken = common.tool.getCookie('skey');
  }
  const sign = md5(`${url}${openid}${accessToken}${appid}${timeStamp}${params}`).toString()  ;
  const requestData = {
    request: {
      cmd: url,
      acct_type: acctType,
      appid,
      openid,
      access_token: accessToken,
      timestamp: timeStamp,
      sign,
      req: params,
    },
  };
  const requestUrl =  'https://capiv2.xinyue.qq.com/cgi-bin/vip_qzproxy.fcgi?cmd=jjsonrouter';
  return  await  Vue.prototype.$axiosInstance.post(requestUrl, JSON.stringify(requestData));
};

export  {
  queryGameInfo,
  queryUserSubscription,
  saveMobSubscription,
  getCommonRecommendEncodeCardByScene,
  getTgclubPhoneBind,
  reportSilentDownload,
  queryGamePackageName,
};

export  default  {
  queryGameInfo,
  queryUserSubscription,
  saveMobSubscription,
  getCommonRecommendEncodeCardByScene,
  getTgclubPhoneBind,
  reportSilentDownload,
  queryGamePackageName,
};

